import React from 'react'
import { Spinner, Center, HStack, Button } from '@chakra-ui/react'
import { useAddResearch } from './hooks/useAddResearch'
import { AddResearchForm } from './components/AddResearchForm'
import TagManagementSection from '../EditResearch/components/TagManagementSection'

const AddResearchPage: React.FC = () => {
  const {
    // Data
    tags,
    selectedTags,
    newTagName,
    
    // State
    loading,
    saving,
    showTagError,
    canManageResearch,
    
    // Form
    register,
    handleSubmit,
    errors,
    isSubmitting,
    
    // Tag management
    setNewTagName,
    handleAddNewTag,
    handleRemoveTag,
    handleSelectTag,
    setShowTagError,
    
    // Navigation
    onCancel
  } = useAddResearch()

  // Loading state
  if (loading) {
    return (
      <Center h='50vh'>
        <Spinner size='xl' color='blue.500' />
      </Center>
    )
  }

  // Permission check
  if (!canManageResearch) {
    return (
      <Center h='50vh'>
        <div>You don't have permission to add research articles.</div>
      </Center>
    )
  }

  return (
    <AddResearchForm
      onSubmit={handleSubmit}
      register={register}
      errors={errors}
    >
      {/* Tag Management Section */}
      <TagManagementSection
        tags={tags}
        selectedTags={selectedTags}
        newTagName={newTagName}
        showTagError={showTagError}
        saving={saving}
        setNewTagName={setNewTagName}
        handleSelectTag={handleSelectTag}
        handleRemoveTag={handleRemoveTag}
        handleAddNewTag={handleAddNewTag}
        setShowTagError={setShowTagError}
      />

      {/* Submit Buttons */}
      <HStack justify='flex-end' spacing={4}>
        <Button
          variant='outline'
          onClick={onCancel}
          isDisabled={isSubmitting || saving}
        >
          Cancel
        </Button>
        <Button
          type='submit'
          colorScheme='blue'
          isLoading={isSubmitting || saving}
          loadingText='Adding...'
        >
          Add Research
        </Button>
      </HStack>
    </AddResearchForm>
  )
}

export default AddResearchPage